import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import styles from './styles.js'
import classNames from 'classnames'
import LoadingIndicator from '../../../../../../../../Components/LoadingIndicator/LoadingIndicator.js'
import TableSortLabel from '@material-ui/core/TableSortLabel'

const NoShowTrackerTable = ({
  data,
  headers,
  classes,
  openViewModal,
  orderBy,
  order,
  onSort,
  onClickItem,
  isLoading,
}) => {
  const renderTableCell = ({ row, key, type, openViewModal }) => {
    switch (type) {
      case 'string':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {'-'}
          </Typography>
        )

      case 'review':
        return (
          <div
            className={classNames(classes.nmbrsModalButton, classes.comment)}
            onClick={() => openViewModal(row)}
          >
            View
          </div>
        )
      case 'date':
        return (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {row && row[key]
              ? moment(Number(row[key])).format('YYYY-MM-DD HH:mm')
              : '-'}
          </Typography>
        )

      default:
        return null
    }
  }

  return (
    <Box className={classes.wrapper}>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <Box className={classes.table}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader size="small">
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.tableRow}>
                  {headers.map((headCell, index) => (
                    <TableCell
                      key={headCell.key}
                      align={index === headers.length - 1 ? 'center' : 'left'}
                      className={classNames({
                        [classes.tableHeaderCell]: index !== 0,
                        [classes.firstTableHeaderCell]: index === 0,
                        [classes.commentWrapper]: [
                          'comment',
                          'internalComment',
                        ].includes(headCell.key),
                      })}
                    >
                      {headCell.sort ? (
                        <TableSortLabel
                          active={orderBy === headCell.key}
                          direction={orderBy === headCell.key ? order : 'asc'}
                          onClick={onSort(headCell.key)}
                        >
                          {headCell.label}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map(row => {
                    return (
                      <TableRow
                        hover
                        onClick={() => onClickItem(row)}
                        tabIndex={-1}
                        key={row.id}
                        className={classes.tableRow}
                      >
                        {headers.map(({ key, type }, index) => (
                          <TableCell
                            key={`${key}-${index}`}
                            align={
                              index === headers.length - 1 ? 'center' : 'left'
                            }
                          >
                            {renderTableCell({
                              row,
                              key,
                              type,
                              openViewModal,
                            })}
                          </TableCell>
                        ))}
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  )
}

export default injectStyles(styles)(NoShowTrackerTable)
